import * as types from './constants';
import { langsListDefault } from '~/utils/config';
import lang from '~/languageProvider/i18n/locale';

const DEFAULT_LOCALE_EN = 'en';
const DEFAULT_LANGUAGE_CODE_EN = 'en_us';

const initialState = {
  locale: {
    iso: DEFAULT_LOCALE_EN,
    language_code: DEFAULT_LANGUAGE_CODE_EN,
  },
  dataTrans: {},
  langsList: langsListDefault,
  langJson: {
    DEFAULT_LOCALE_EN: lang.en_GB,
  },
  activeDefault: DEFAULT_LANGUAGE_CODE_EN,
  deviceLangs: DEFAULT_LOCALE_EN,
};

const languageProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_LOCALE:
      return {
        ...state,
        locale: action.locale.code,
        activeDefault: action.locale.active,
      };
    case types.DEVICE_LOCALE:
      return {
        ...state,
        deviceLangs: action.locale,
      };
    case types.GET_DATA_TRANS:
      return {
        ...state,
        dataTrans: action.payload,
      };
    case types.CHANGE_LOCALE_LIST:
      return {
        ...state,
        langsList: action.payload,
      };
    case types.UPDATE_JSON_LANG:
      return {
        ...state,
        langJson: action.payload,
      };
    default:
      return state;
  }
};

export default languageProviderReducer;
